module.exports = __webpack_public_path__ + "static/media/check_item_details.a475e94c.svg";